module.exports = __webpack_public_path__ + "static/media/3B.1ae2f455.jpg";